import CartView from '../views/Cart.vue'
import CheckoutView from '../views/Checkout.vue'
import EditCartItem from '../views/EditCartItem.vue'
import CheckoutShipAddress from '../components/CheckoutShipAddress.vue'
import CheckoutShipMethod from '../components/CheckoutShipMethod.vue'
import CheckoutBilling from '../components/CheckoutBilling.vue'
import CheckoutReview from '../components/CheckoutReview.vue'
import CheckoutComplete from '../components/CheckoutComplete.vue'
import useSessionKeeper from '../composables/useSessionKeeper'
import useCart from '../composables/useCart'
import useCheckout from '../composables/useCheckout'
import useProgress from '../composables/useProgress'
import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Cart',
    component: CartView,
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutView,
    children: [
      {
        path: 'ship-address',
        name: 'Ship Address',
        component: CheckoutShipAddress,
      },
      {
        path: 'ship-method',
        name: 'Ship Method',
        component: CheckoutShipMethod,
      },
      {
        path: 'billing',
        name: 'Billing',
        component: CheckoutBilling,
      },
      {
        path: 'review',
        name: 'Review',
        component: CheckoutReview,
      },
      {
        path: 'complete',
        name: 'Complete',
        component: CheckoutComplete,
      },
    ],
  },
  {
    path: '/edit-cart-item/:id',
    name: 'Edit Cart Item',
    component: EditCartItem,
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((...[to, , next]) => {
  const { startSession } = useSessionKeeper()

  //on first step of checkout we need to sync the cart session with the checkout session
  if (to.name === 'Ship Address') {
    const { syncWithCheckout } = useCart()
    syncWithCheckout()
  }

  startSession()

  const { checkAndPreventProgress } = useProgress()
  if (checkAndPreventProgress(to)) {
    next()
  }
})

router.onReady(() => {
  const { info: checkoutInfo } = useCheckout()

  if (!checkoutInfo.value.isQuote && router.history.current.name != 'Cart') {
    router.push({ path: '/' })
    // } else if (checkoutInfo.value.isQuote && router.history.current.name != 'Review'){
    //     //quote checkout starts at review since other info is set from quote
    //     router.push({ name: 'Review' });
    // }
  } else if (checkoutInfo.value.isQuote && router.history.current.name != 'Billing') {
    //quote checkout starts at billing since other info is set from quote
    router.push({ name: 'Billing' })
  }
})

export default router
